import { BillType } from '@mews-commander/data-access';
import { RouteName } from '@mews-commander/enums';
import { CommanderThunkAction } from '@mews-commander/types';
import { navigateInModal, openModal } from '../../app/actions/common';
import { getRealBillId } from '../actions/utils';
import { logBillingAction } from '../utils/logBillingAction';
import { getBillingAccountUrl } from '../../navigation/billing';

export const NAME = 'navigation';

export const openAccountBillingModal =
    ({ accountId }: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe) => {
        const url = getBillingAccountUrl(getState(), { accountId });
        return dispatch(openModal(url));
    };

export const navigateToAccountBillingModal =
    ({ accountId, billId }: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe) => {
        const url = getBillingAccountUrl(getState(), { accountId, id: billId });

        return dispatch(navigateInModal(url));
    };

export const openBillPreview =
    ({ billId }: $TSFixMe): CommanderThunkAction =>
    (dispatch, getState, { resolveRoute }) => {
        const url = resolveRoute(RouteName.BillPreviewCreatePreview, { query: { billId } });
        return dispatch(openModal(url));
    };

export const openCreateProforma =
    ({ billId }: $TSFixMe): CommanderThunkAction =>
    (dispatch, getState, { resolveRoute }) => {
        const url = resolveRoute(RouteName.BillPreviewCreateProforma, { query: { billId } });

        return dispatch(openModal(url));
    };

export const openIssueInvoice =
    ({ billId }: $TSFixMe): CommanderThunkAction =>
    (dispatch, getState, { resolveRoute }) => {
        const url = resolveRoute(RouteName.BillClose, { id: billId, query: { type: BillType.Invoice } });

        return dispatch(openModal(url));
    };

export const openCloseBill =
    ({ billId, scope }: $TSFixMe): CommanderThunkAction =>
    async (dispatch, getState, { resolveRoute }) => {
        const finalBillId = await dispatch(getRealBillId({ billId, scope }));
        const url = resolveRoute(RouteName.BillClose, { id: finalBillId, query: { type: BillType.Receipt } });

        dispatch(logBillingAction('navigated to close bill'));
        return dispatch(openModal(url));
    };
